<!-- splash screen -->
<div #splashScreen class="m-splash-screen">
	<img [attr.src]="splashScreenImage" style="width: 90px; margin-bottom: 30px;" alt="Logo">
	<!--here we will have circle progress bar-->
	<mat-spinner diameter="40"></mat-spinner>
</div>

<router-outlet></router-outlet>